import { useMainStore } from "@/store/main";

import { HorizontalMenu } from "@/components/Common/HorizontalMenu/HorizontalMenu";

export const MainMenu = () => {
  const tool = useMainStore((state) => state.tool);
  return <HorizontalMenu items={tool.menuItems} />;
};
